"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileImageUploadModule = /** @class */ (function () {
    function UserProfileImageUploadModule() {
    }
    return UserProfileImageUploadModule;
}());
exports.UserProfileImageUploadModule = UserProfileImageUploadModule;
